// src/analytics/utm.js
const STORAGE_KEY = 'monite_utm';
const TTL_DAYS = 30;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];

export function captureUtmFromUrl() {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const captured = {};
  let hasAny = false;
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) {
      captured[key] = value;
      hasAny = true;
    }
  }
  if (hasAny) {
    const payload = { ...captured, capturedAt: new Date().toISOString() };
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      // localStorage indisponible (Safari private, quota) — silent fail
    }
  }
}

export function getPersistedUtm() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data.capturedAt) return null;
    const ageMs = Date.now() - new Date(data.capturedAt).getTime();
    const ttlMs = TTL_DAYS * 24 * 60 * 60 * 1000;
    if (ageMs > ttlMs) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    const { capturedAt, ...utmOnly } = data;
    return utmOnly;
  } catch (e) {
    return null;
  }
}

export function clearPersistedUtm() {
  try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
}
